<div class="topHead">
    <!--(click)="onBackToAuthCr()"-->
    <a href="javascript:void(0);" class="adminBack" (click)="onBackToAuthCr()"
        *ngIf="this.assData != null && this.assData != ''">
        <img src="assets/images/admin/backarrow.png" /> Back to create course management
    </a>
    <a href="javascript:void(0);" class="adminBack" (click)="open(backModle)"
        *ngIf="this.assData == null || this.assData == ''">
        <img src="assets/images/admin/backarrow.png" /> Back to create course management
    </a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png" /> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="formHeading pr-0">
    <div class="row m-0">
        <div class="col-12 col-md-8">
            <h2>Add Assessment</h2>
            <p>Please add instructions & constuct questions</p>
        </div>
    </div>
</div>
<form [formGroup]="createAssessmentForm">
    <div class="centerWrap">
        <div class="col-12">
            <div class="commanInput commanTextarea">
                <div class="closeIcon"></div>
                <div class="titleDis">Add Instructions</div>
                <!-- <ckeditor tagName="textarea"  formControlName="assessment_instruction" placeholder="Enter Description"
                    [config]="{ toolbar: [ [ 'Bold', 'Italic', 'BulletedList', 'NumberedList' ] ] }"
                    [ngClass]="{ 'is-invalid': submitted && f.assessment_instruction.errors }">
                </ckeditor> -->
                <ckeditor tagName="textarea" formControlName="assessment_instruction" placeholder="Enter Description" (change)="autoSave()"
                    [config]="{ toolbar: [ [ 'Bold', 'Italic', 'NumberedList', 'Strike', 'BulletedList', 'Format'], ['Table']] }">
                </ckeditor>
                <!-- <mat-hint align="end">{{assessment_instruction.value.length}} / 250 characters</mat-hint> -->
            </div>
            <div *ngIf="submitted && f.assessment_instruction.errors">
                <div *ngIf="f.assessment_instruction.errors.required" class="text-mute text-danger errorText">This field
                    is required</div>
                <div *ngIf="f.assessment_instruction.errors.cannotContainSpace" class="text-mute text-danger errorText">
                    CapsuleName can not contain space.</div>
            </div>
        </div>
        <div class="row">
            <div class="col-4">
                <div class="col-6 p-0 d-inline-block align-top">
                    <span class="mainHeading w-100 pl-3 d-flex">Set time limit</span>
                    <div class="addSelect">
                        <div class="selectCustom">
                            <select placeholder="Select" formControlName="assest_time_hr" (change)="onHrChange($event);autoSave()">
                                <option value="">Select</option>
                                <option *ngFor='let in of counterData' [ngValue]="in.value">
                                    {{in.label}}
                                </option>
                            </select>
                        </div>
                        <b>Hrs</b>
                    </div>
                    <div *ngIf="submitted && f.assest_time_hr.errors">
                        <div *ngIf="f.assest_time_hr.errors.required" class="text-mute text-danger errorText pl-3">This
                            field is required</div>
                    </div>
                </div>
                <div class="col-6 p-0 d-inline-block align-top">
                    <span class="mainHeading w-100 pl-3 d-flex">&nbsp;</span>
                    <div class="addSelect">
                        <div class="selectCustom">
                            <select formControlName="assest_time_min" (change)="onMinChange($event); autoSave()">
                                <option value="">Select</option>
                                <option *ngFor='let in of counterMinuites' [ngValue]="in.value">
                                    {{in.label}}
                                </option>
                            </select>
                        </div>
                        <b>Min</b>
                    </div>
                    <div *ngIf="minError == '2'">
                        <div *ngIf="minError =='2'" class="text-mute text-danger errorText pl-3">Please select more than
                            00 min</div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <span class="mainHeading w-100 d-flex">Passing Criteria</span>
                <div class="addSelect">
                    <span>Internal:</span>
                    <div class="selectCustom border-0">
                        <div class="commanInput">
                            <mat-form-field class="example-full-width">
                                <input matInput formControlName="internal_org_pass_no_of_questions"
                                    (keyup)=internalValidate() (change)="autoSave()" >
                            </mat-form-field>
                            <div *ngIf="submitted && f.internal_org_pass_no_of_questions.errors"
                                class="internalErrorTest">
                                <div *ngIf="f.internal_org_pass_no_of_questions.errors.required"
                                    class="text-mute text-danger text-nowrap errorText pl-3">This field is required
                                </div>
                                <div *ngIf="f.internal_org_pass_no_of_questions.errors.pattern"
                                    class="text-mute text-danger text-nowrap errorText pl-3">Enter only number and zero
                                    not
                                    accecpt
                                </div>
                            </div>
                            <div *ngIf="internalValidateError == 1"
                                class="text-mute text-danger text-nowrap errorText pl-3 internalErrorTest">Enter only
                                number and zero not
                                accecpt</div>
                            <div *ngIf="internalError == 1"
                                class="text-mute text-danger text-nowrap errorText pl-3 internalErrorTest">
                                Enter equal or less than number of question</div>
                        </div>
                    </div>
                    <b>Correct Answers</b>
                </div>
            </div>
            <div class="col-3">
                <span class="mainHeading w-100 d-flex">&nbsp;</span>

                <div class="addSelect">
                    <span>External:</span>
                    <div class="selectCustom border-0">
                        <div class="commanInput">
                            <mat-form-field class="example-full-width">
                                <input matInput formControlName="external_org_pass_no_of_questions" (change)="autoSave()"
                                    (keyup)=externalValidate()>
                            </mat-form-field>
                        </div>
                        <div class="errorRequir">
                            <div *ngIf="submitted && f.external_org_pass_no_of_questions.errors">
                                <div *ngIf="f.external_org_pass_no_of_questions.errors.required"
                                    class="text-mute text-danger text-nowrap errorText pl-3">This field is required
                                </div>
                                <div *ngIf="f.external_org_pass_no_of_questions.errors.pattern"
                                    class="text-mute text-danger text-nowrap errorText pl-3">Enter only number and zero
                                    not
                                    accecpt</div>
                            </div>
                            <div *ngIf="externalValidateError == 1"
                                class="text-mute text-danger text-nowrap errorText pl-3">Enter only number and zero not
                                accecpt</div>
                            <div *ngIf="ExternalError == 1" class="text-mute text-danger text-nowrap errorText pl-3">
                                Enter
                                equal or less than number of question</div>
                        </div>
                    </div>
                    <b>Correct Answers</b>
                </div>
            </div>
        </div>

        <div (cdkDropListDropped)="drop($event)" cdkDropList>
            <div class="questionDropWrap" formArrayName="questions" class="example-list">
                <div class="addQuestions mb-3">Add Questions</div>
                <div *ngFor="let itemrow of createAssessmentForm.controls.questions['controls']; let i=index">
                    <div cdkDrag [formGroupName]="i">
                        <ngb-accordion #a="ngbAccordion" activeIds="custom-panel-1">
                            <ngb-panel id="custom-panel-1">
                                <ng-template ngbPanelHeader let-opened="opened">
                                    <div class="add_QuestionsHeading">
                                        <b><img src="assets/images/admin/drog.png" /></b>
                                        <span>Question {{i+1}}</span>
                                        <button class="ml-auto" ngbPanelToggle><img
                                                src="assets/images/admin/dropdown.png" /></button>
                                    </div>
                                </ng-template>
                                <ng-template ngbPanelContent>
                                    <div class="add_Questions_Wrap">
                                        <div class="commanRadio">
                                            <div class="title">Question Type</div>
                                            <mat-radio-group formControlName="question_type" (change)="autoSave()">
                                                <mat-radio-button value="1"
                                                    (change)="questionTypes(i,questionTypes_Obj.MCQ,itemrow.controls.responses)">Multiple
                                                    Choice Question</mat-radio-button>
                                                <mat-radio-button value="2"
                                                    (change)="questionTypes(i,questionTypes_Obj.TF,itemrow.controls.responses)">True/False
                                                </mat-radio-button>
                                                <mat-radio-button value="3"
                                                    (change)="questionTypes(i,questionTypes_Obj.MTF,itemrow.controls.responses)">Match
                                                    the
                                                    following
                                                </mat-radio-button>

                                                <!-- new validation is added in radio button Milan -->
                                                <div
                                                    *ngIf="createAssessmentForm.get('questions').controls[i].get('question_type')?.dirty && createAssessmentForm.get('questions').controls[i].get('question_type')?.errors">
                                                    <div *ngIf="createAssessmentForm.get('questions').controls[i].get('question_type').errors.required"
                                                        class="text-mute text-danger errorText">This field is required
                                                    </div>
                                                </div>

                                            </mat-radio-group>
                                        </div>
                                        <div class="questionArea">
                                            <div class="col-12">
                                                <div class="commanInput commanTextarea">
                                                    <mat-form-field class="example-full-width">
                                                        <mat-label>Question</mat-label>
                                                        <textarea matInput placeholder="Enter Description"
                                                            formControlName="question_text" (change)="autoSave()"></textarea>
                                                    </mat-form-field>
                                                    <div
                                                        *ngIf="createAssessmentForm.get('questions').controls[i].get('question_text')?.dirty && createAssessmentForm.get('questions').controls[i].get('question_text')?.errors">
                                                        <div *ngIf="createAssessmentForm.get('questions').controls[i].get('question_text').errors.required"
                                                            class="text-mute text-danger errorText">This field is
                                                            required
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="galleryInputBox"
                                                    *ngIf="!createAssessmentForm.get('questions').controls[i].get('question_asset_url').value">
                                                    <div class="galleryInput">
                                                        <input type="file" (change)="uploadFileProgress(i,$event)"
                                                            accept="image/x-png,image/gif,image/jpeg" />
                                                        <span><img src="assets/images/admin/image-gallery.png" /> Upload
                                                            image</span>
                                                    </div>
                                                </div>
                                                <div class="viewUploadWrap"
                                                    *ngIf="createAssessmentForm.get('questions').controls[i].get('question_asset_url').value">
                                                    <div class="viewUpload">
                                                        <figure>
                                                            <span href="javascript:void(0);"
                                                                (click)="deleteImgRow(i)"><img
                                                                    src="assets/images/admin/plus_circle.svg" /></span>
                                                            <img
                                                                [src]="createAssessmentForm.get('questions').controls[i].get('question_asset_url').value" />
                                                        </figure>
                                                        <div class="blueUploadWrap">
                                                            <b class="name"></b>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <ng-container
                                                *ngIf="createAssessmentForm.get('questions').controls[i].get('question_type').value==1">
                                                <div class="col-12">
                                                    <span class="mainHeading w-100 d-flex mb-2 mt-4">Options</span>
                                                    <div class="w-75" formArrayName="responses" (change)="autoSave()">
                                                        <div class="commanInput optionInput"
                                                            *ngFor="let responserow of itemrow.controls.responses.controls; let o=index">
                                                            <div [formGroupName]="o" class="d-flex align-items-center">
                                                                <mat-form-field class="example-full-width">
                                                                    <span matPrefix>Option {{o+1}} &nbsp;</span>
                                                                    <input type="tel" matInput
                                                                        formControlName="response">
                                                                </mat-form-field>
                                                                <div
                                                                    *ngIf="responserow.get('response')?.dirty && responserow.get('response')?.errors">
                                                                    <div *ngIf="responserow.get('response').errors.required"
                                                                        class="text-mute text-danger errorText">This
                                                                        field is required</div>
                                                                </div>
                                                                <span href="javascript:void(0);"
                                                                    (click)="deleteOptionRow(i,o)"
                                                                    *ngIf="itemrow.controls.responses.controls.length > 2"><img
                                                                        src="assets/images/admin/plus_circle.svg" /></span>
                                                            </div>
                                                        </div>

                                                        <div class="addMoreQuestion addAnother"
                                                            *ngIf="itemrow.controls.responses.controls.length+1 <= 6">
                                                            <a href="javascript:void(0);"
                                                                (click)="addNewOptions({index: i, question_type: questionTypes_Obj.MCQ})">+
                                                                add another Option</a>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="col-12">
                                                    <div class="ansWrap mt-4">
                                                        <div class="commanRadio">
                                                            <div class="title">Correct Answer</div>
                                                            <mat-radio-group formControlName="correct_response_no" (change)="autoSave()">
                                                                <span
                                                                    *ngFor="let responserows of itemrow.controls.responses.controls; let j=index">
                                                                    <mat-radio-button value={{j+1}}>Option
                                                                        {{j+1}}</mat-radio-button>
                                                                </span>
                                                            </mat-radio-group>
                                                            <div
                                                                *ngIf="createAssessmentForm.get('questions').controls[i].get('correct_response_no')?.dirty && createAssessmentForm.get('questions').controls[i].get('correct_response_no')?.errors">
                                                                <div *ngIf="createAssessmentForm.get('questions').controls[i].get('correct_response_no').errors.required"
                                                                    class="text-mute text-danger errorText">This field
                                                                    is
                                                                    required</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </ng-container>
                                            <ng-container
                                                *ngIf="createAssessmentForm.get('questions').controls[i].get('question_type').value==2">
                                                <div class="col-12">
                                                    <span class="mainHeading w-100 d-flex mb-2 mt-4">Options</span>
                                                    <div class="w-100 ansdisable">
                                                        <div class="w-25 ansdisable" formArrayName="responses" (change)="autoSave()">
                                                            <div class="commanInput optionInput">
                                                                <div class="commanInput optionInput"
                                                                    *ngFor="let responserow of itemrow.controls.responses.controls; let k=index">
                                                                    <div [formGroupName]="k">
                                                                        <mat-form-field class="example-full-width">
                                                                            <span matPrefix>Option {{k+1}} &nbsp;</span>
                                                                            <input type="tel" *ngIf="k+1==1" readonly
                                                                                value="True" matInput
                                                                                formControlName="response">
                                                                            <input type="tel" *ngIf="k+1==2" readonly
                                                                                value="False" matInput
                                                                                formControlName="response">
                                                                        </mat-form-field>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="w-100 ansdisable">
                                                        <div class="w-25 ansdisable" formArrayName="responses">
                                                            <div class="commanInput optionInput">
                                                                <mat-form-field class="example-full-width">
                                                                    <span matPrefix>Option 1 &nbsp;</span>
                                                                    <input type="tel" matInput value="True" readonly formControlName="response">
                                                                </mat-form-field>
                                                            </div>
                                                            <div class="commanInput optionInput">
                                                                <mat-form-field class="example-full-width">
                                                                    <span matPrefix>Option 2 &nbsp;</span>
                                                                    <input type="tel" matInput value="False" readonly formControlName="response">
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                    </div> -->
                                                </div>
                                                <div class="col-12">
                                                    <div class="ansWrap mt-4">
                                                        <div class="commanRadio">
                                                            <div class="title">Correct Answer</div>
                                                            <mat-radio-group formControlName="correct_response_no" (change)="autoSave()">
                                                                <span
                                                                    *ngFor="let responserows of itemrow.controls.responses.controls; let j=index">
                                                                    <mat-radio-button value={{j+1}}>Option
                                                                        {{j+1}}</mat-radio-button>
                                                                </span>
                                                            </mat-radio-group>
                                                            <div
                                                                *ngIf="createAssessmentForm.get('questions').controls[i].get('correct_response_no')?.dirty && createAssessmentForm.get('questions').controls[i].get('correct_response_no')?.errors">
                                                                <div *ngIf="createAssessmentForm.get('questions').controls[i].get('correct_response_no').errors.required"
                                                                    class="text-mute text-danger errorText">This field
                                                                    is
                                                                    required</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                            <ng-container
                                                *ngIf="createAssessmentForm.get('questions').controls[i].get('question_type').value==3">
                                                <div class="col-12">
                                                    <div class="row p-0 w-75">
                                                        <div class="col-12 col-md-6"><span
                                                                class="mainHeading w-100 d-flex mb-2 mt-4">Options</span>
                                                        </div>
                                                        <div class="col-12 col-md-6"><span
                                                                class="mainHeading w-100 d-flex mb-2 mt-4 ml-4">Correct
                                                                Answer</span></div>
                                                    </div>
                                                    <div class="w-75" formArrayName="responses">
                                                        <div [formGroupName]="o" class="commanInput optionInput"
                                                            *ngFor="let responserow of itemrow.controls.responses.controls; let o=index">
                                                            <div class="row p-0 flex-nowrap align-items-center">
                                                                <div class="w-100 d-flex">
                                                                    <div class="col-12 col-md-6">
                                                                        <div class="commanInput optionInput">
                                                                            <mat-form-field class="example-full-width">
                                                                                <span matPrefix>Option {{o+1}}
                                                                                    &nbsp;</span>
                                                                                <input type="tel" matInput
                                                                                    formControlName="response" (change)="autoSave()">
                                                                            </mat-form-field>
                                                                            <div
                                                                                *ngIf="itemrow.controls.responses.controls[o].get('response')?.dirty && itemrow.controls.responses.controls[o].get('response')?.errors">
                                                                                <div *ngIf="itemrow.controls.responses.controls[o].get('response').errors.required"
                                                                                    class="text-mute text-danger errorText">
                                                                                    This field
                                                                                    is
                                                                                    required</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-12 col-md-6">
                                                                        <div class="commanInput optionInput">
                                                                            <mat-form-field class="example-full-width">
                                                                                <!-- <span matPrefix>Option {{o+1}} &nbsp;</span> -->
                                                                                <input type="tel" matInput
                                                                                    formControlName="response_match">
                                                                            </mat-form-field>
                                                                            <div
                                                                                *ngIf="itemrow.controls.responses.controls[o].get('response_match')?.dirty && itemrow.controls.responses.controls[o].get('response_match')?.errors">
                                                                                <div *ngIf="itemrow.controls.responses.controls[o].get('response_match').errors.required"
                                                                                    class="text-mute text-danger errorText">
                                                                                    This field
                                                                                    is
                                                                                    required</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            
                                                            <span href="javascript:void(0);"
                                                                (click)="deleteOptionRow(i,o)"
                                                                *ngIf="itemrow.controls.responses.controls.length > 2"><img
                                                                    src="assets/images/admin/plus_circle.svg" /></span>
                                                        </div>
                                                    </div>
                                                        <div class="addMoreQuestion addAnother"
                                                            *ngIf="itemrow.controls.responses.controls.length+1 <= 6">
                                                            <a href="javascript:void(0);"
                                                                (click)="addNewOptions({index: i, question_type: questionTypes_Obj.MTF})">+
                                                                add another Option</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>

                                        </div>
                                        <span class="deletBtn" *ngIf="i!=0" (click)="deleteRow(i)"><img
                                                src="assets/images/admin/plus_circle.svg" /></span>
                                    </div>
                                </ng-template>
                            </ngb-panel>
                        </ngb-accordion>
                    </div>
                </div>
            </div>
        </div>
        <div class="addMoreQuestion">
            <a href="javascript:void(0);" (click)="addNewRow()">+ add Question</a>
        </div>
        <div class="row m-0 text-center justify-content-center align-items-center ">
            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="open(cancelModle)">Cancel</a>
            <a href="javascript:void(0);" class="backPage ml-2 mr-2" (click)="open(resetModle)">Reset</a>
            <a href="javascript:void(0);" class="btn btn-primary btn-sm ml-1 mr-1"
                (click)="createModuleAss(createAssessmentForm.value, '')"><span>Save Assessment</span></a>

        </div>
    </div>
    <input type="hidden" (click)="open(imgValidat)" id="errorImg">
</form>
<!--assessment delete modal-->
<ng-template #cancelModle let-modal>
    <div class="modal-body" *ngIf="activeCanMod">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Cancel Assessment</h6>
                <p class="size18">Are you sure you would like to cancel this assessment?</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" (click)="onBackToAuthCr()" class="btn btn-primary btn-sm">Confirm</a>

            </div>
        </div>
    </div>
</ng-template>
<ng-template #backModle let-modal>
    <div class="modal-body" *ngIf="activeCanMod">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Back to course management
                </h6>
                <p class="size18">Are you sure you would like to back then you will be loss your asssessment fill data
                </p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" (click)="onBackToAuthCr()" class="btn btn-primary btn-sm">Confirm</a>

            </div>
        </div>
    </div>
</ng-template>
<ng-template #resetModle let-modal>
    <div class="modal-body" *ngIf="activeCanMod">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Reset Assessment</h6>
                <p class="size18">Are you sure you would like to reset this assessment?</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" (click)="resetAssForm()" class="btn btn-primary btn-sm">Confirm</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #imgValidat let-modal>
    <div class="modal-body" *ngIf="activeCanMod">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <h6>Reset Assessment</h6>
                <p class="size18">Are you sure you would like to reset this assessment?</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">Cancel</a>
                <a href="javascript:void(0);" (click)="resetAssForm()" class="btn btn-primary btn-sm">Confirm</a>
            </div>
        </div>
    </div>
</ng-template>

<ngx-spinner>
    <p style="color: white"> Loading... </p>
</ngx-spinner>